import { useQuery } from 'react-query';
import { supabase } from '../lib/supabaseClient';

interface RegionalPlan {
  id: string;
  name: string;
  description: string;
  credits: number;
  duration_days: number;
  price: number;
  currency_code: string;
  currency_symbol: string;
  is_active: boolean;
  is_popular: boolean;
}

export const useRegionalPricing = (regionCode: string = 'US') => {
  const { data: plans = [], isLoading, error } = useQuery<RegionalPlan[]>(
    ['subscription-plans', regionCode],
    async () => {
      try {
        // Fetch plans with regional pricing from the database
        const { data, error } = await supabase
          .rpc('get_regional_plans', {
            p_region_code: regionCode
          });

        if (error) throw error;
        
        return data || [];
      } catch (error) {
        console.error('Error fetching regional plans:', error);
        
        // Fallback to default USD pricing
        return [
          {
            id: '1',
            name: 'Daily Pass',
            description: '24-hour access with 20 searches',
            credits: 20,
            duration_days: 1,
            price: 499, // $4.99
            currency_code: 'USD',
            currency_symbol: '$',
            is_active: true,
            is_popular: false
          },
          {
            id: '2',
            name: 'Weekly Pro',
            description: '7-day access with 100 searches',
            credits: 100,
            duration_days: 7,
            price: 1999, // $19.99
            currency_code: 'USD',
            currency_symbol: '$',
            is_active: true,
            is_popular: false
          },
          {
            id: '3',
            name: 'Monthly Premium',
            description: 'Most Popular! 30-day access with 500 searches',
            credits: 500,
            duration_days: 30,
            price: 4999, // $49.99
            currency_code: 'USD',
            currency_symbol: '$',
            is_active: true,
            is_popular: true
          }
        ];
      }
    },
    {
      staleTime: 60 * 60 * 1000, // 1 hour
      cacheTime: 24 * 60 * 60 * 1000 // 24 hours
    }
  );

  return {
    plans,
    isLoading,
    error
  };
};